import {Component, Inject, OnDestroy, OnInit, PLATFORM_ID} from '@angular/core';
import { Store } from '@ngrx/store';
import {BehaviorSubject, Observable, Subject, Subscription} from 'rxjs';
import * as fromShoppingCart from '@app/marketplace/products/state/shopping-cart/cart-state';
import * as selectorsShoppingCart from '@app/marketplace/products/state/shopping-cart/cart-selectors';
import * as locationSelectors from '@app/marketplace/locations/state/locations-selectors';
import * as locationsActions from '@app/marketplace/locations/state/locations-actions';
import * as searchActions from "@app/marketplace/products/state/product-search/search-actions";
import * as categoryActions from "@app/marketplace/categories/state/category/categories-actions";
import * as productActions from "@app/marketplace/products/state/product-list/list-actions";
import * as searchSelectors from '@app/marketplace/products/state/product-search/search-selectors';
import { LocationTypeEnum } from '@app/marketplace/shared/_models/location.model';
import { initProvinces } from '@app/marketplace/locations/locations';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { FormControl } from '@angular/forms';
import {debounceTime, distinctUntilChanged, takeUntil} from 'rxjs/operators';
import {StorageService} from '@app/services/storage.service';
import {NavigationEnd, NavigationStart, Router} from '@angular/router';
import {environment} from '@env/environment';


@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.css']
})
export class TopbarComponent implements OnInit, OnDestroy {

  location$: Observable<any>;
  LocationType = LocationTypeEnum;

  locations = initProvinces;
  locationType: LocationTypeEnum;
  province = '';
  municipality = '';
  shoppingCart$: Observable<fromShoppingCart.State>;

  payload: any;
  searhControl = new FormControl("");
  protected _subscriptions: Subscription[] = [];
  unsubscribe = new Subject();
  stop = false;
  showMegaMenuSubject = new BehaviorSubject({});
  showMegaMenu$ = this.showMegaMenuSubject.asObservable();
  provider$: Observable<any>;
  isCheckoutPage = false;

  turnOnShein = environment.turn_on_shein;
  turnOnAmazon = environment.turn_on_amazon;
  turnOnWalmart = environment.turn_on_walmart;
  turnOnHomeDepot = environment.turn_on_homedepot;
  turnOnBestBuy = environment.turn_on_bestbuy

  constructor(private store: Store<any>,
    public storageService: StorageService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId,
    @Inject(DOCUMENT) private document) {
    this.location$ = this.store.select(locationSelectors.selectLocation);
    this.provider$ = this.store.select(searchSelectors.selectProvider);
  }

  handleClick(event) {
    event.preventDefault();
    var href=event.currentTarget.getAttribute('data-href')
    if(href){
      this.store.dispatch(searchActions.SetProvider({provider:0}));
      this.store.dispatch(searchActions.DeleteSearchTerm());
      this.router.navigate([href]);
    }
  }
  ngOnInit(): void {
    this.showMegaMenu$
      .pipe(debounceTime(500))
      .subscribe(() => {
        if (!this.stop) {
          const megaBox = this.document.querySelector('.mega-box.collapse');
          if (megaBox) {
            megaBox.classList.remove('collapse');
          }
        } else { this.stop = false; }
    });
    this._subscriptions.push(this.location$.subscribe((res: any) => {
      if (res.locations.length === 0) {
        this.province = '';
        this.municipality = '';
      } else {
        this.locationType = res.locationType;
        if (res.locationType == LocationTypeEnum.Municipality) {
          this.province = this.locations.find(x => x.children.find(o => o.value == res.locations[0]))?.iso || '';
          const mun = this.locations.find(x => x.children.find(o => o.value == res.locations[0]))?.children.find(t => t.value == res.locations[0])?.text || '';
          if (mun.length > 15) {
            this.municipality = `${mun.slice(0, 15)}...`;
          } else { this.municipality = mun; }
        } else {
          this.municipality = '';
          this.province = this.locations.find(x => x.value == res.locations[0])?.text || '';
        }
      }

    }));

    if (isPlatformBrowser(this.platformId)) {
      this.document.querySelector('.mega-menu').addEventListener('mouseenter', () => this.onEvent());
      this.document.querySelector('.mega-menu').addEventListener('mouseleave', () => { this.stop = true; });
      this.document.querySelector('.mega-menu').addEventListener('touchstart', () => this.onEvent1());
      this.document.querySelector('.sidemenu').addEventListener('mouseenter', () => this.onEvent(false));
      this.document.querySelector('.sidemenu').addEventListener('touchstart', () => this.onEvent(false));
      this.shoppingCart$ = this.store.select(selectorsShoppingCart.selectCart);
     /*  this._subscriptions.push(this.searhControl.valueChanges
        .pipe(debounceTime(250), distinctUntilChanged())
        .subscribe((val) => {
            this.store.dispatch(searchActions.KeyPressInSearch({term: val}));
            if(val.length===0)
              this.store.dispatch(searchActions.SearchProducts());
        })); */

        this._subscriptions.push(this.router.events.subscribe((e: any) => {
          if (e instanceof NavigationStart) {
            this.isCheckoutPage = e.url !== '/market/revisar-completar-pedido';
            if(e.url==="/market/tienda-online-cuba"){
              this.store.dispatch(categoryActions.ClearCategoryFilter());
              let payload= {
                "pageIndex": 1,
                "pageSize": 8,
                "pagingStrategy": 0,
                "locationType": 0,
                "locations": null,
                "locationResolver": false,
                "filter": {
                  "searchTerms": "",
                  "sortingArgs": 0,
                  "categories": null,
                  "priceRange": {
                    "low": 1,
                    "high": 250
                  }
                },
                "categoryCode": '',
                "supplierCode": ""
              };
              this.store.dispatch(categoryActions.ListCategories({payload}));
            }
          }
        }));

    }
  }
  onEvent(megaMenu: boolean = true) {
    if (megaMenu) {
      this.stop = false;
      this.showMegaMenuSubject.next({});
    } else {
      const gtMenu = this.document.querySelector('.gt-menu.collapse');
      if (gtMenu) {
        gtMenu.classList.remove('collapse');
      }
    }
  }

  onEvent1(megaMenu: boolean = true) {
    if (megaMenu) {
      const megaBox = this.document.querySelector('.mega-box.collapse');
      if (megaBox) {
        megaBox.classList.remove('collapse');
      }
    } else {
      const gtMenu = this.document.querySelector('.gt-menu.collapse');
      if (gtMenu) {
        gtMenu.classList.remove('collapse');
      }
    }
  }

 /*  search=()=>this.store.dispatch(searchActions.SearchProducts()); */

  action(code, locationType: LocationTypeEnum = LocationTypeEnum.Municipality) {
    const aux = this.document.getElementsByClassName('mega-box');
    aux[0].classList.add('collapse');
    this.store.dispatch(locationsActions.UpdatedLocation({ locationType: locationType, locations: [code] }));
    //this.router.navigate(['/market/productos-compras-cuba-online']);
  }
  collapseMenu () {
    const aux = this.document.getElementsByClassName('gt-menu');
    aux[0].classList.add('collapse');
  }

  productRouter=()=>{
    this.store.dispatch(searchActions.SetProvider({provider:0}));
    this.store.dispatch(searchActions.DeleteSearchTerm());
    this.store.dispatch(categoryActions.ClearCategoryFilter());
    let payload = {
      pageIndex: 0,
      pageSize: 12,
      pagingStrategy: 0,
      locationType: 0,
      locations: null,
      locationResolver: false,
      filter: {
        searchTerms: '',
        sortingArgs: 0,
        categories: null,
        priceRange: {
          low: 1,
          high: 1000,
        },
      },
      categoryCode: '',
      supplierCode: '',
    };
    this.store.dispatch(productActions.LoadingProductsAction({payload}));
    this.router.navigate(['market/productos-compras-cuba-online']);
  }

  ngOnDestroy(): void {
    this.document.querySelector('.mega-menu').removeEventListener('mouseenter', () => this.onEvent());
    this.document.querySelector('.mega-menu').removeEventListener('mouseleave', () => { this.stop = true; });
    this.document.querySelector('.mega-menu').removeEventListener('touchstart', () => this.onEvent1());
    this.document.querySelector('.sidemenu').removeEventListener('mouseenter', () => this.onEvent(false));
    this.document.querySelector('.sidemenu').removeEventListener('touchstart', () => this.onEvent(false));
    this._subscriptions.forEach(sb => sb.unsubscribe());
  }
}
